import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Spacing } from '../../components/entities-card/Spacing';
import { PopoverWrapper } from '../../components/popovers/wrapper/PopoverWrapper';
import { EntitiesCardFooter } from '../../components/entities-card/EntitiesCardFooter';
import { EntitiesCardBody } from '../../components/entities-card/EntitiesCardBody';
import { EntitiesTitleLink } from '../../components/entities-card/EntitiesTitleLink';
import { CommentaryCountChip } from './CommentaryCountChip';
import styles from './decision_popover.module.scss';
import { TimelineChip } from '../../document-analyzer/components/chip/TimelineChip';

type Props = {
  title: string;
  summary?: string;
  href?: string;
  target?: '_blank';
  commentaryCount?: number;
  timelineCountAfter?: number;
  handleClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const DecisionPopover: FC<Props> = ({
  title,
  summary,
  href,
  handleClick,
  target,
  commentaryCount,
  timelineCountAfter,
}) => {
  return (
    <PopoverWrapper>
      <EntitiesCardBody>
        <EntitiesTitleLink href={href} onClick={handleClick} target={target}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EntitiesTitleLink>
        {commentaryCount && (
          <div className={styles.chips}>
            {!!commentaryCount && (
              <span className={styles.chip}>
                <CommentaryCountChip count={commentaryCount} />
              </span>
            )}

            {!!timelineCountAfter && (
              <span className={styles.chip}>
                <TimelineChip count={timelineCountAfter} />
              </span>
            )}
          </div>
        )}
        <Spacing />
        {summary && (
          <p
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: summary }}
          />
        )}
      </EntitiesCardBody>
      <EntitiesCardFooter href={href} onClick={handleClick} target={target}>
        <FormattedMessage id="decision/popover/DecisionPopover.tsx/1" />
      </EntitiesCardFooter>
    </PopoverWrapper>
  );
};
